import { createLazyFileRoute } from "@tanstack/react-router";

import { SubjectSamplesView } from "@/features/subjects/components/SubjectSamplesView";

export const Route = createLazyFileRoute("/_auth/_app/subjects/$id/samples")({
  component: RouteComponent,
});

function RouteComponent() {
  const { sampleId } = Route.useSearch();
  return <SubjectSamplesView sampleId={sampleId} />;
}
